import React, { useEffect } from "react";
import {
  Button,
  Form,
  Modal,
  Row,
  Col,
  Table,
} from "@themesberg/react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faPlus,
  faSave,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import StockService from "../../../../services/StockService";
const AddPurchaseModal = (props) => {
  const { show, handleClose, setShow, productsListe, suppliersListe } = props;
  const [update, setUpdate] = useState(0);
  const [supplier, setSupplier] = useState({});
  const [product, setProduct] = useState({});
  const [supplier_id, setSupplierId] = useState();
  const [comment_purchase, setCommentPurchase] = useState("");
  const [tva, setTva] = useState("");
  const [products, setProducts] = useState([]);
  const [product_id, setProductId] = useState();
  const [quantity, setQuantity] = useState();
  const [total_price, setTotalPrice] = useState();
  const [unit_price, setUnitPrice] = useState();
  const [purchase_date, setPurchaseDate] = useState();
  const [comment, setComment] = useState();

  const updateSupplier = (id) => {
    setSupplier([...suppliersListe].filter((s) => s.id == id)[0]);
  };

  const updateProduct = (id) => {
    setProduct([...productsListe].filter((p) => p.id == id)[0]);
  };

  const updateProducts = (array) => {
    // Step 1: Group the items by category_id
    let grouped = array.reduce((acc, item) => {
      if (!acc[item.category_id]) {
        acc[item.category_id] = [];
      }
      acc[item.category_id].push(item);
      return acc;
    }, {});

    // Step 2: Convert the grouped object into a nested array format
    let nestedArray = Object.keys(grouped)
      .sort((a, b) => a - b)
      .map((key) => grouped[key]);
    console.log("nested ===>", nestedArray);
    return nestedArray;
  };

  useEffect(() => {
    // setPhones(inputs);
    updateProducts(productsListe);
  }, [update]);

  const resetForm = () => {
    setProduct({});
    setProductId("");
    setComment("");
    setTotalPrice("");
    setUnitPrice("");
    setQuantity("");
  };

  const addProduct = () => {
    setProducts([
      ...products,
      {
        product,
        product_id,
        total_price,
        unit_price,
        quantity,
        comment,
        purchase_date,
      },
    ]);
    setUpdate((prev) => prev + 1);
    console.log(products);
    resetForm();
  };
  const editProduct = (pr) => {
    setProduct(pr.product);
    setProductId(pr.product_id);
    setComment(pr.comment);
    setTotalPrice(pr.total_price);
    setUnitPrice(pr.unit_price);
    setQuantity(pr.quantity);
    setUpdate((prev) => prev + 1);
  };

  const deleteProduct = (id) => {
    setProducts([...products].filter((p) => p.product_id != id));
    console.log(
      "after delete ===>",
      id,
      [...products].filter((p) => p.product_id != id)
    );
    setUpdate((prev) => prev + 1);
  };

  const addPurchase = async (e) => {
    e.preventDefault();

    try {
      const res = await StockService.addPurchase({
        ...{ comment: comment_purchase },
        tva,
        supplier_id,
        products,
      });
      if (res.status === 200) {
        NotificationManager.success(res.data.message, "Stock");
        handleClose();
      }
    } catch (err) {
      NotificationManager.error(err?.response?.data?.message, "Stock");
    }
  };

  return (
    <>
      <Modal
        as={Modal.Dialog}
        centered
        show={show}
        onHide={handleClose}
        size={"xl"}
      >
        <Modal.Header>
          <Modal.Title className="h6">
            <FontAwesomeIcon icon={faPlus} /> Ajouter nouveau achat
          </Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <div className={""}>
            <Form onSubmit={addPurchase}>
              <Row>
                <Col>
                  {" "}
                  <Form.Group>
                    <Form.Label>Date</Form.Label>
                    <Form.Control
                    
                      value={purchase_date}
                      type="date"
                      onChange={(e) => setPurchaseDate(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </Col>
                <Col>
                  {" "}
                  <Form.Group>
                    <Form.Label>Choisir un fournisseur</Form.Label>
                    <select
                      className="form-control"
                      value={supplier_id}
                      onChange={(e) => {
                        setSupplierId(e.target.value);
                        updateSupplier(e.target.value);
                      }}
                    >
                      {suppliersListe &&
                        suppliersListe.map((s, index) => (
                          <option value={s.id}>{s.company_name}</option>
                        ))}
                    </select>
                  </Form.Group>
                </Col>
              </Row>
              <Table className="mt-2">
                <thead>
                  <tr>
                    <th>Produit</th>
                    <th>Qunatie</th>
                    <th>Prix unitaire</th>
                    <th>Prix total</th>
                    <th>Commentaire</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map((p) => (
                    <tr>
                      <td> {p.product.name} </td>
                      <td> {p.quantity} </td>
                      <td>{p.unit_price}</td>
                      <td> {p.total_price}</td>

                      <td>{p.comment}</td>
                      <td>
                        <Button
                          title="Editer"
                          className="me-2 btn-sm"
                          onClick={() => {
                            editProduct(p);
                            deleteProduct(p.product_id);
                          }}
                        >
                          <FontAwesomeIcon icon={faPen} />
                        </Button>
                        <Button
                          title="Supprimer"
                          className="me-2 btn-sm"
                          variant="danger"
                          onClick={() => deleteProduct(p.product_id)}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td>
                      {" "}
                      <select
                        className="form-control"
                        value={product_id}
                        onChange={(e) => {
                          setProductId(e.target.value);
                          updateProduct(e.target.value);
                        }}
                      >
                        {productsListe &&
                          updateProducts(productsListe).map((p, index) => (
                            <optgroup label={p[0].category.name}>
                              {p.map((pr) => (
                                <option value={pr.id}>{pr.name}</option>
                              ))}
                            </optgroup>
                          ))}
                      </select>{" "}
                    </td>
                    <td>
                      <Form.Control
                        min={1}
                        type="number"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        placeholder="Quantite ..."
                      ></Form.Control>
                    </td>

                    <td>
                      <Form.Control
                        type="number"
                        onChange={(e) => setUnitPrice(e.target.value)}
                        value={unit_price}
                        placeholder="Prix unitaire ..."
                      ></Form.Control>
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        onChange={(e) => setTotalPrice(e.target.value)}
                        value={total_price}
                        placeholder="Prix total ..."
                      ></Form.Control>
                    </td>
                    <td>
                      <Form.Control
                        onChange={(e) => setComment(e.target.value)}
                        value={comment}
                        placeholder="Commentaire ..."
                      ></Form.Control>
                    </td>
                    <td>
                      <Button onClick={addProduct}>
                        <FontAwesomeIcon icon={faPlus} />
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Commentaire achat</Form.Label>
                    <Form.Control
                      onChange={(e) => setCommentPurchase(e.target.value)}
                      value={comment_purchase}
                      placeholder="Commentaire achat ..."
                    ></Form.Control>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Total facture</Form.Label>
                    <Form.Control
                      type="number"
                      onChange={(e) => setTva(e.target.value)}
                      value={tva}
                      placeholder="Total facture ..."
                    ></Form.Control>
                  </Form.Group>
                </Col>
                <Col className="d-flex justify-content-end mt-5">
                  <Button variant="main" type="submit">
                    <FontAwesomeIcon icon={faSave} className="me-2" />
                    Sauvegarder
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddPurchaseModal;
